import * as React from 'react';

interface Row {
  ntrp: string;
  utr: string;
  wtn: string;
  itn: string;
  description: string;
}

const ROWS: Row[] = [
  {
    ntrp: '1.5',
    utr: '~1',
    wtn: '~38',
    itn: '10.2',
    description: 'Just starting tennis; learning grip, contact, and how to keep balls in the court.',
  },
  {
    ntrp: '2.0',
    utr: '~1.5',
    wtn: '~34',
    itn: '10.1',
    description: 'Building consistency; serves go in but lack pace; needs help with positioning.',
  },
  {
    ntrp: '2.5',
    utr: '~2.5',
    wtn: '~28',
    itn: '9',
    description: 'Sustained short rallies; recognizable forehand and backhand; basic serve.',
  },
  {
    ntrp: '3.0',
    utr: '~3.5',
    wtn: '~22',
    itn: '8',
    description: 'Reliable groundstrokes at moderate pace; working second serve; some net play.',
  },
  {
    ntrp: '3.5',
    utr: '~5',
    wtn: '~17',
    itn: '7',
    description: 'Variety in pace and spin; aware of court positioning; competitive league play.',
  },
  {
    ntrp: '4.0',
    utr: '~7',
    wtn: '~12',
    itn: '6',
    description: 'Dependable strokes from both wings; targeted serves; tactical patterns of play.',
  },
  {
    ntrp: '4.5',
    utr: '~9',
    wtn: '~8',
    itn: '5',
    description: 'Power and accuracy; reliable second serve; advanced doubles strategy.',
  },
  {
    ntrp: '5.0',
    utr: '~11',
    wtn: '~5',
    itn: '4',
    description: 'Sectional / open-tournament level; consistent under pressure.',
  },
  {
    ntrp: '5.5',
    utr: '~12',
    wtn: '~3',
    itn: '3',
    description: 'National-tournament level; aggressive shot-making with control.',
  },
  {
    ntrp: '6.0–7.0',
    utr: '13+',
    wtn: '~1–2',
    itn: '1–2',
    description: 'College-elite, national-circuit, and pro caliber.',
  },
];

export default function ComparisonTable() {
  return (
    <div className="ratings-table overflow-x-auto border-y border-color-divider-lightmode-primary dark:border-color-divider-darkmode-primary">
      <table className="w-full min-w-[640px] text-left">
        <thead>
          <tr>
            <th className="typography-product-body text-sm px-4 py-3 font-semibold text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              UTR
            </th>
            <th className="typography-product-body text-sm px-4 py-3 font-semibold text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              NTRP
            </th>
            <th className="typography-product-body text-sm px-4 py-3 font-semibold text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              WTN
            </th>
            <th className="typography-product-body text-sm px-4 py-3 font-semibold text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              ITN
            </th>
            <th className="typography-product-body text-sm px-4 py-3 font-semibold text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              What this looks like
            </th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row) => (
            <tr
              key={row.ntrp}
              className="border-b border-color-divider-lightmode-primary last:border-0 dark:border-color-divider-darkmode-primary"
            >
              <td className="typography-product-body px-4 py-3 font-medium text-color-bg-lightmode-brand">
                {row.utr}
              </td>
              <td className="typography-product-body px-4 py-3 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                {row.ntrp}
              </td>
              <td className="typography-product-body px-4 py-3 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                {row.wtn}
              </td>
              <td className="typography-product-body px-4 py-3 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                {row.itn}
              </td>
              <td className="typography-product-body px-4 py-3 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                {row.description}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
